<template>
    <div class="loginbg" style="display: none;">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form @submit.prevent="emailVerify();" id="forgotPassword">
                            <div class="form-group">
                                <label for="inputEmail1">Email</label>
                                <input id="inputEmail1" v-model="email" v-validate="'required|email'" type="email" placeholder="Email Address" name="email" class="form-control">
                                <span class="color-c3202b float-l width-full font-text-regular-san" v-if="errors.has('email')">{{errors.first('email')}}</span>
                            </div>
                            
                            <span id="errorMsg" class="color-c3202b float-l width-full font-text-regular-san"></span>
                            <span id="successMsg" class="color-71aa3f float-l width-full font-text-regular-san pb-10"></span>

                            <div>
                                <button id="sendEmail" class="btn general-button btn-primary" >Submit</button>
                                <router-link href="javascript:void(0)" v-bind:to="'/login'">Back</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</template>
<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import SessioMixin from '../mixins/sessionmixin';
    Vue.use(VeeValidate);
    export default {
        name: 'ForgotPassword',
        mixins: [SessioMixin],
        data() {
            return {
                email: '',
            }
        },
        mounted: function () {
            $('.navbar').hide();
            $('#errorMsg,#successMsg').hide();
            $('.footer-main').hide();
            $('html,body,#app').css({height: "100%"});
            if(window.location.pathname == "/forgotpassword") {
                $(".app-sidebar-right").css("padding-left","0px");
                $(".app-sidebar-right").css("margin-top","0px");
                $(".app-sidebar-right").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
                $(".loginbg").show();
            }
            var self = this;
            var tokenData = self.$route.query.token;
            var emailData = self.$route.query.email;
            // console.log(tokenData);

            if (tokenData != undefined)
            {
                $.ajax({
                    url: process.env.ROOT_API + "/checkuser",
                    type: "GET",
                    crossDomain: true,
                    data: {
                        tokenValue: tokenData,
                        email: emailData
                    },
                    dataType: 'json',
                    success: function (data) {
                        // console.log(data.content);
                        if (data.status == "success") {
                            self.$router.push("/resetpassword/" + data.content);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        if (jqXHR.status == 0) {
                            self.registerError = "Remote server can not be reachable";
                        }
                    }
                });
            }
        },
        methods: {
            emailVerify() {
                // console.log('LoginForm');
                this.$validator.validate().then(result => {
                    if (result) {
                        var app = this;
                        $('#errorMsg').html('');
                        $('#successMsg').html('');
                        $('#errorMsg,#successMsg').hide();
                        $('#sendEmail').html('Submiting...');
                        $('#sendEmail').prop('disabled', true);
                        // console.log(app.email);
                        $.ajax({
                            url: process.env.ROOT_API + "/checkuser",
                            type: "GET",
                            crossDomain: true,
                            dataType: 'json',
                            data: {email: app.email},
                            success: function (data) {
                                //console.log(data.code);
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (data.status == "success") {
                                    $('#sendEmail').prop('disabled', true);
                                    // $('.navbar').show();
                                    // //self.timezones = data.content;
                                    // window.localStorage.setItem("api_token",data.content.api_token);
                                    // window.localStorage.setItem("user_obj",JSON.stringify(data.content.user_obj));
                                    // /*app.$router.push("/");*/
                                    // app.$router.push("/listcustomer");
                                    $('#successMsg').show();
                                    $('#successMsg').html(data.message);
                                    setTimeout(function () {
                                        $('#sendEmail').prop('disabled', false);
                                        app.$router.push("/login");
                                    }, 5000);
                                }
                                if (data.code != 200) {
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(data.message);
                                }
                            },
                            error: function (jqXHR, exception) {
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                self.Registerbtn = "Register";
                                if (jqXHR.status == 0) {
                                    self.registerError = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(jqXHR.responseJSON.message);
                                }
                            }
                        });
                    }
                });
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue